import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSkillsSvg } from "./IconSkillsSvg.mjs";
const IconSkills = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSkillsSvg, ...svgProps }) });
export {
  IconSkills
};
